<div class="form-content" [formGroup]="form">
  <div class="section">
    <div class="section-header">
      <h4>{{ 'brand.prepTime.orderIntervals' | translate }}</h4>
    </div>

    <div class="section-content">
      <div>
        <mat-slide-toggle data-qa-label="IntervalsEnabled"
                          formControlName="intervalsEnabled">
          {{ 'store.dynamicPrepTime.intervalsEnabled' | translate }}
        </mat-slide-toggle>
      </div>

      <div>
        <label>{{ 'store.dynamicPrepTime.orderThresholdInterval' | translate }}</label>

        <mat-form-field class="minutes-per-interval">
          <mat-label>{{ 'store.dynamicPrepTime.interval' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 data-qa-label="MinutesPerInterval"
                 formControlName="orderThresholdInterval">
          <mat-error *ngIf="form.get('orderThresholdInterval')?.errors?.required">
            {{ 'form.error.required' | translate}}
          </mat-error>
          <mat-error *ngIf="form.get('orderThresholdInterval')?.errors?.min">
            {{ 'form.error.minValueShort' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <label>{{ 'store.dynamicPrepTime.orderThresholdMaxOrders' | translate }}</label>

        <mat-form-field class="max-orders">
          <mat-label>{{ 'store.dynamicPrepTime.maximum' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 data-qa-label="MaxOrders"
                 formControlName="orderThresholdMaxOrders">
          <mat-error *ngIf="form.get('orderThresholdMaxOrders')?.errors?.required">
            {{ 'form.error.required' | translate}}
          </mat-error>
          <mat-error *ngIf="form.get('orderThresholdMaxOrders')?.errors?.min">
            {{ 'form.error.minValueShort' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <label>{{ 'store.dynamicPrepTime.orderThresholdAdditionalTime' | translate }}</label>

        <mat-form-field class="additional-time">
          <mat-label>{{ 'store.dynamicPrepTime.minutes' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 data-qa-label="OrderAdditionalTime"
                 formControlName="orderThresholdAdditionalTime">
          <mat-error *ngIf="form.get('orderThresholdAdditionalTime')?.errors?.required">
            {{ 'form.error.required' | translate}}
          </mat-error>
          <mat-error *ngIf="form.get('orderThresholdAdditionalTime')?.errors?.min">
            {{ 'form.error.minValueShort' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="section-header with-button">
      <h4>{{ 'brand.prepTime.itemExempt' | translate }}</h4>
      <txp-button
        data-qa-label="CreateNewButton"
        [style]="buttonStyle.SECONDARY"
        [size]="buttonSize.SMALL"
        (click)="handleAddEntity()">
        {{ 'store.dynamicPrepTime.addProduct' | translate }}
      </txp-button>
    </div>

    <div class="section-content">
      <div *ngIf="form.get('orderThresholdExemptItems').value?.length > 0">
        <label>{{ 'store.dynamicPrepTime.orderThresholdExemptionRule' | translate }}</label>

        <mat-form-field class="exempt-items">
          <mat-label>{{ 'store.dynamicPrepTime.interval' | translate }}</mat-label>
          <mat-select
            matInput
            formControlName="orderThresholdExemptionRule"
            data-qa-label="ExemptionRule"
            required>
            <mat-option *ngFor="let type of exemptTypes" [value]="type">{{ 'store.dynamicPrepTime.orderExemptRule.' + type | translate }}</mat-option>
          </mat-select>
          <mat-error>
            {{ 'form.error.required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="entity-ids-list"
           cdkDropList
           (cdkDropListDropped)="onItemDrop($event)">
        <div *ngFor="let entity of form.get('orderThresholdExemptItems').value" class="item"
             cdkDrag
             [cdkDragData]="entity.sku">
            <span class="drag-icon">
                <i class="tce-icon-grip"></i>
            </span>
          <div class="name">
            <div class="item-name">
              {{ entity.name }}
            </div>
          </div>
          <a class="action"
             *ngIf="!disabled"
             (click)="handleDelete(entity)"
             [attr.title]="'form.button.remove' | translate"
             data-qa-label="DeleteButton">
            <i class="tce-icon-trash remove-icon"></i>
          </a>
        </div>
      </div>

      <div *cdkDragPlaceholder></div>
    </div>
  </div>
</div>
